import React, { createContext } from 'react';
import Scroll from 'react-scroll';
import { Route, IndexRedirect } from 'react-router';
import queryString from 'query-string';
import { camGroupSuccess } from './actions/camgroups';
import { channelFeedSuccess } from './actions/channels';
import {
  setDefaultItem,
  setGlobalCountries,
  setGlobalWebsiteBackgrounds,
  setInitialLoad, setLogo,
  setSnapshotsEnabled,
  setCurrentSection,
  fetchStaticPage,
  setInitialLoadError, checkApiStatus,
} from './actions/globalConfig';
import App from './app';
import { currentItemSuccess, setCurrentItemBySlug, setCurrentItemByUsername, setSectionTitleFromCamgroup, setSelectedItem } from './actions/currentItem';
import { checkToken, setCamerasToken } from './actions/auth';
import { getMetadataForPage } from './actions/metadata';
import { setAlerts } from './actions/alerts';
import { offsetFromWrapper, checkHttpStatus, parseJSON } from './utils';
import InitialLoad from './components/InitialLoad';
import {
  HomeView,
  LoginView,
  ProtectedView,
  NotFoundView,
  SocialLoginView,
  SearchView,
  MemberProfile,
  MemberIndexView,
  StaticView,
  GrantsView,
  EventsView,
  FaqsView,
  HelpTutorialVideosView,
  FilmsView,
  PhotosView,
  PearlsOfThePlanetView,
  NewsletterPageView,
  UnsubscribedPageView,
  PopComments,
  PopLivecam,
  TestimonialsView,
  FixedTemplateView,
  PhotoGalleryView,
  VolunteerPageView,
} from './containers';
import LivecamPreview from './containers/LiveCam/LivecamPreview';
import StaticWrap from './containers/Static/StaticWrap';
import PopDisqusComments from './containers/PopDisqusComments';
import {
  SnapshotFavoritesGallery,
  SnapshotUserGallery,
  SnapshotContestGallery,
  SnapshotGallery,
  SnapshotGroupGallery,
  SnapshotAllGallery,
} from './containers/Snapshots/SnapshotPageVariants';
import SnapshotGalleryProvider from './contexts/SnapshotGalleryContext';
import BoundaryWrapper from './components/ErrorBoundaryComponent';

const LiveCam = InitialLoad;

export default (store) => {
  const loadAllLivecamdata = (nextState, callback) => {
    const state = store.getState();
    if (state.globalConfig.initialDataLoaded) {
      callback(nextState);
      return;
    }
    const pageTypes = [
      'home',
      'userFavorites',
      'userFavorites',
      'livecams',
      'livecams',
      'search',
      'search',
      'membersIndex',
      'members',
    ];

    let initialParams = {};
    const path = window.location.pathname;
    const patterns = [
      /^\/?(livecams)\/?$/, // $1 = content type
      /^\/?(livecams)\/members\/([^/]+)\/?$/, // $1 = contenttype $2 = group
      /^\/?(livecams)\/members\/([^/]+)\/([-\w]+)\/?$/, // $1 = contenttype $2 = group $3 mediaobject
      /^\/?(livecams)\/([-\w]+)\/?$/, // $1 = contenttype $2 = group
      /^\/?(livecams)\/([-\w]+)\/([-\w]+)\/?$/,
      /^\/?(search)\/?$/, // $1 = content type
      /^\/?(search)\/(.*)\/?$/, // $1 =contenttype $2 = query
      /^\/?(members)\/?$/, // $1 = content type
      /^\/?(search)\/(.*)\/?$/, // $1 =contenttype $2 = query
    ];

    for (let i = 0; i < patterns.length; i += 1) {
      const test = path.match(patterns[i]);
      if (test) {
        initialParams = {
          contenttype: test[1],
          mediaObject: test[3],
          pageType: pageTypes[i],
        };

        if (test[1] && (test[1] === 'search' || test[1] === 'members')) {
          initialParams.query = test[2];
        } else {
          initialParams.group = test[2];
        }
        break;
      }
    }

    const params = queryString.stringify(initialParams);

    const fetchRetry = (url, options, n) => {
      return fetch(url, options)
        .then(checkHttpStatus)
        .then(parseJSON)
        .catch((error) => {
          if (n === 1) throw error;
          return fetchRetry(url, options, n - 1);
        });
    };

    fetchRetry(`${SERVER_URL}/initial?${params}`, {
      method: 'GET',
      // credentials: 'same-origin',
      headers: {
        'Content-Type': 'x-www-form-urlencoded',
      },
    }, 10).then((response) => {
      const {
        alerts,
        // userPreferences,
        camgroups,
        channels,
        countries,
        default_livecam,
        website_backgrounds,
        snapshotsEnabled,
        snapshotToken,
        logo,
      } = response.data;
      // store.dispatch(setUserPreferences(userPreferences));
      store.dispatch(setAlerts(alerts));
      store.dispatch(channelFeedSuccess(channels));
      store.dispatch(setDefaultItem(default_livecam));
      store.dispatch(setGlobalCountries(countries));
      store.dispatch(setGlobalWebsiteBackgrounds(website_backgrounds));
      store.dispatch(setSnapshotsEnabled(snapshotsEnabled));
      store.dispatch(camGroupSuccess(camgroups));
      store.dispatch(setInitialLoad(true));
      store.dispatch(setLogo(logo));
      if (snapshotToken) {
        store.dispatch(setCamerasToken(snapshotToken));
      }
      callback(nextState);
    })
    .catch((e) => {
      console.log(e);
      store.dispatch(setInitialLoadError(e));
    });
  };

  const setDefaultCam = (nextState, replace) => {
    const state = store.getState();
    if (state.globalConfig.defaultItem) {
      store.dispatch(setSelectedItem(state.globalConfig.defaultItem.id));
      store.dispatch(currentItemSuccess(state.globalConfig.defaultItem));
      store.dispatch(setCurrentSection(setSectionTitleFromCamgroup(state.globalConfig.defaultItem.cam_group)));
    }
  };

  const setUserLivecams = (nextState) => {
    const state = store.getState();
    store.dispatch(setCurrentItemByUsername(nextState.params, state.cam_groups.data));
  };

  const setLivecamBySlug = (nextState) => {
    const state = store.getState();
    store.dispatch(setCurrentItemBySlug(nextState.params, state.cam_groups.data));
  };

  const setPageByContent = content => () => {
    store.dispatch(fetchStaticPage(content));
    store.dispatch(setCurrentSection('extra'));
  };

  const setPageByContent2 = ({ location }) => {
    const content = location.pathname.slice(1);
    store.dispatch(fetchStaticPage(content));
    store.dispatch(setCurrentSection('extra'));
  };


  const checkResetToken = (nextState) => {
    store.dispatch(checkToken(nextState.params.code));
  };

  const setSection = (sectionTitle) => {
    store.dispatch(setCurrentSection(sectionTitle));
  };

  const scrollToTop = () => {
    Scroll.animateScroll.scrollToTop();
  };

  const getInitialMetadata = ({ location }) => {
    if (location) {
      store.dispatch(getMetadataForPage(location.pathname));
      store.dispatch(checkApiStatus());
    }
  }

  const handleChange = (previousRoute, nextRoute) => {
    if (!(previousRoute.routes[1].livecam && nextRoute.routes[1].livecam && !nextRoute.routes[1].livecamroot) &&
        !(previousRoute.location.pathname === nextRoute.location.pathname && nextRoute.location.pathname.includes('/snapshots')) &&
        !nextRoute.location.pathname.includes('/help')) {
      scrollToTop();
    }
    if (nextRoute.routes[1]) {
      store.dispatch(getMetadataForPage(nextRoute.location.pathname));
    }

    if (nextRoute.routes[1].livecam) {
      if (typeof _tkf !== 'undefined' && _tkf.loadDeclaredCalendars) {
        let gap = 0;
        for (let i = 0; i < 20; i++) {
          gap += 50;
          setTimeout(function () {
            _tkf.loadDeclaredCalendars();
          }, gap);
        }
      }
    }
    store.dispatch(checkApiStatus());
  };

  return (
    <div>
      <Route onEnter={nextState => loadAllLivecamdata(nextState, setLivecamBySlug)} name="popDisqusComments" path="/livecams/disqus/:group/:mediaobject" component={PopDisqusComments} />
      <Route onEnter={nextState => loadAllLivecamdata(nextState, setLivecamBySlug)} name="popComments" path="/livecams/comments/:group/:mediaobject" component={PopComments} />
      <Route onEnter={nextState => loadAllLivecamdata(nextState, setLivecamBySlug)} name="popLivecam" path="/livecams/player/:group/:mediaobject" component={PopLivecam} />
      <Route path="/" onEnter={getInitialMetadata} onChange={handleChange} component={App}>
        <IndexRedirect to="/livecams" />
        <Route onEnter={nextState => loadAllLivecamdata(nextState, setDefaultCam)} name="livecams" path="/livecams" component={LiveCam} livecam livecamroot />
        <Route onEnter={nextState => loadAllLivecamdata(nextState, () => { })} name="livecamPreview" path="/livecams/preview/:mediaobject" component={LivecamPreview} livecam />
        <Route onEnter={nextState => loadAllLivecamdata(nextState, setUserLivecams)} name="livecamsMember" path="/livecams/members/:group" component={LiveCam} user livecam />
        <Route onEnter={nextState => loadAllLivecamdata(nextState, setUserLivecams)} name="livecamsMember" path="/livecams/members/:group/:mediaobject" component={LiveCam} user livecam />
        <Route onEnter={nextState => loadAllLivecamdata(nextState, setLivecamBySlug)} name="livecamsMediaObject" path="/livecams/:group/:mediaobject" component={LiveCam} livecam />
        <Route onEnter={nextState => loadAllLivecamdata(nextState, setLivecamBySlug)} name="livecamsGroup" path="/livecams/:group" component={LiveCam} livecam />
        <Route name="authSocial" path="/accounts/register" component={SocialLoginView} />
        <Route name="authSocial" path="/accounts/login" component={SocialLoginView} />
        <Route name="search" path="/search" component={SearchView} />
        <Route name="search" path="/search/:term" component={SearchView} />
        <Route name="memberIndex" path="/members" component={MemberIndexView} />
        <Route name="memberProfile" path="/members/:username" component={MemberProfile} />
        <Route name="memberProfile" path="/members/:username/:section" component={MemberProfile} />
        <Route name="grants" path="/grants" component={GrantsView} />
        <Route name="event-calendar" path="/event-calendar" component={EventsView} />
        <Route name="faq" path="/help" component={FaqsView} />
        <Route name="password_reset" path="/accounts/reset/:code" component={LiveCam} onEnter={checkResetToken} />
        <Route name="films" path="/films" component={FilmsView} />
        <Route onEnter={nextState => loadAllLivecamdata(nextState, () => { })} name="pearlsOfThePlanet" path="/pearls-of-the-planet" component={PearlsOfThePlanetView} />
        <Route name="newsletter" path="/subscribe" component={NewsletterPageView} onEnter={(e) => { setSection('Newsletter'); }} />
        <Route name="volunteer" path="/volunteer" component={VolunteerPageView} onEnter={(e) => { setSection('Volunteer'); }} />
        <Route name="unsubscribed" path="/unsubscribed" component={UnsubscribedPageView} onEnter={(e) => { setSection('Unsubscribed'); }} />

        <Route name="testimonials" path="/testimonials" component={TestimonialsView} onEnter={(e) => { setSection('Testimonials'); }} />
        <Route name="photoGalleries" path="/photos" component={PhotosView}  onEnter={(e) => { setSection('Photos'); }} />
        <Route name="photoGallery" path="/photos/:gallerySlug" component={PhotoGalleryView} />

        <Route path="signup" component={() => (<FixedTemplateView template="SignUpView" />)} />

        <Route component={SnapshotGalleryProvider} >
          <Route name="snapshots" path="/snapshots/favorites/:favusername" component={BoundaryWrapper(SnapshotFavoritesGallery)} />
          <Route name="snapshots" path="/snapshots/users/:username" component={BoundaryWrapper(SnapshotUserGallery)} />
          <Route name="snapshots" path="/snapshots/contests/:contestslug" component={BoundaryWrapper(SnapshotContestGallery)} />
          <Route name="snapshots" path="/snapshots/gallery/:galleryslug" component={BoundaryWrapper(SnapshotGallery)} />
          <Route name="snapshots" path="/snapshots/:group" component={BoundaryWrapper(SnapshotGroupGallery)} />
          <Route name="snapshots" path="/snapshots" component={BoundaryWrapper(SnapshotAllGallery)} />
        </Route>

        <Route path="*" component={StaticWrap} onEnter={setPageByContent2} staticPage />
      </Route>
    </div>
  );
};
